export default __webpack_public_path__ + "static/media/TheClient.1131c4e6.webp";